import React, { Suspense, lazy } from 'react';
import { Loader } from '../Loader';

export function withLazyComponent(Component, options = {}) {
  return props => {
    return (
      <Suspense fallback={<Loader fullscreen={options.loadingFullScreen} />}>
        <Component {...props} />
      </Suspense>
    )
  };
}

const lazyComponent = (fn, options) => withLazyComponent(lazy(fn), options)
export default lazyComponent